// extracted by mini-css-extract-plugin
module.exports = {"legend":"LineChartWithCustomLegend_legend__CBW8U"};